import React, { useEffect } from 'react';
import { connect } from "react-redux";
import qs from "query-string";
import { setWebSessionKey } from "../helpers";
import { iRootState } from "../store";
// @ts-ignore
import { toast } from "cwb-react";

interface Props extends StateProps, DispatchProps {
  children: any;
}

const ProtectedRoute: React.FC<Props> = ({ 
  children, 
  isAuthenticated, 
  loading, 
  forbiddenError,
  createCurrentBridge,
  createSeamlessApi,
  checkCurrentUser,
  getMultipleProfiles
}) => {
  const loadProfilesAfterAuth = async (user: any) => {
    try {
      const clientId = user.id?.userId || user.userId;
      if (clientId) {
        await getMultipleProfiles(clientId.toString());
      }
    } catch (error) {
      toast.error('Error loading profiles. Please try again.');
    }
  };

  useEffect(() => {
    const urlParams = qs.parse(window.location.search);
    const kToken = urlParams.k as string;

    if (!isAuthenticated && loading) {
      if(!kToken){
        checkCurrentUser().then((existingUser) => {
          if (existingUser) {
            if(existingUser.id.userTypeId === 8){
              loadProfilesAfterAuth(existingUser);
              return;
            }else{
              return window.location.href = `${(process.env.REACT_APP_403 || process.env.REACT_APP_CWB_Actor_Login)}${window.location.search}`
            }
          }else{
            createSeamlessApi().then((seamlessResult) => {
              if (seamlessResult && seamlessResult.user) {
                loadProfilesAfterAuth(seamlessResult.user);
              } else {
                return window.location.href = `${(process.env.REACT_APP_401)}${window.location.search}`
              }
            });
          }
        }).catch((error) => {
          console.error('Error checking current user:', error);
          toast.error('Error checking user authentication. Please try again.');
        });
      }

      if (kToken) {
        // console.log('Attempting bridge auth with token:', kToken);
        setWebSessionKey(kToken);
        createCurrentBridge(kToken).then((data) => {
          if (data) {
            if (data.user) {
              loadProfilesAfterAuth(data.user);
            }
          }
        }).catch((error) => {
          createSeamlessApi().then((seamlessResult) => {
            if (seamlessResult && seamlessResult.user) {
              loadProfilesAfterAuth(seamlessResult.user);
            }
          });
        });
      }
    }
  }, []); // Empty dependency array - only run on mount

  if (!isAuthenticated && !loading) {
    if (forbiddenError) {
      return window.location.href = `${(process.env.REACT_APP_403 || process.env.REACT_APP_CWB_Actor_Login)}${window.location.search}`
    } else {
      return (window.location.href = `${process.env.REACT_APP_CWB_Actor_Login}?redirect=${encodeURIComponent(window.location.href)}`);
    }
  }
  
  return children;
};

interface StateProps {
  isAuthenticated: boolean;
  loading: boolean;
  forbiddenError: boolean;
}

const mapStateToProps = (state: iRootState): StateProps => ({
  isAuthenticated: state.authModel.isAuthenticated,
  loading: state.authModel.createCurrentBridgeLoading || 
    state.authModel.createSeamlessApiLoading,
  forbiddenError: state.authModel.forbiddenError
});

interface DispatchProps {
  createCurrentBridge: (kToken: string) => Promise<any>;
  createSeamlessApi: () => Promise<any>;
  checkCurrentUser: () => Promise<any>;
  getMultipleProfiles: (clientId: string) => Promise<any>;
}

function mapDispatchToProps(dispatch: any): DispatchProps {
  return {
    createCurrentBridge: dispatch.authModel.createCurrentBridge,
    createSeamlessApi: dispatch.authModel.createSeamlessApi,
    checkCurrentUser: dispatch.authModel.checkCurrentUser,
    getMultipleProfiles: dispatch.onboardingModel.getMultipleProfiles,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ProtectedRoute);